export const dpFormValidate = (formValues) => {
  let errors = {};

  if (!formValues.dpName) {
    errors.dpName = "Diet Package Name Is Required!";
  }

  if (!formValues.selectedDietCategory) {
    errors.selectedDietCategory = "Diet Category Is Required!";
  }

  if (!formValues.selectedPlanType) {
    errors.selectedPlanType = "Plan Type Is Required!";
  }

  if (
    formValues.selectedDietCategory?.value === "custom" &&
    !formValues.selectedUser
  ) {
    errors.selectedUser = "For Custom Plan User Is Required!";
  }

  if (!formValues.selectedBodyType) {
    errors.selectedBodyType = "Body Type Is Required!";
  }

  if (!formValues.selectedDietPreference) {
    errors.selectedDietPreference = "Diet Preference Is Required!";
  }

  if (!formValues.planDuration) {
    errors.planDuration = "Plan Duration Is Required!";
  }

  if (
    formValues.selectedBodyType?.label?.toLowerCase() !== "maintain" &&
    !formValues.expWeightLoss
  ) {
    errors.expWeightLoss = "Estimated Weight Loss Is Required!";
  }

  if (!formValues.planDesc) {
    errors.planDesc = "Plan Description Is Required!";
  }

  if (!formValues.selectedDays) {
    errors.selectedDays = "Days Select Is Required!";
  }

  const minCal = Number(formValues.minCal);
  const maxCal = Number(formValues.maxCal);

  if (!minCal) {
    errors.minCal = "Minimum Calory Is Required!";
  } else if (minCal && minCal <= 0) {
    errors.minCal = "Minimum Calory Can Not 0 Or Less Than That!";
  }

  if (!maxCal) {
    errors.maxCal = "Maximum Calory Is Required!";
  } else if (maxCal && maxCal <= 0) {
    errors.maxCal = "Maximum Calory Can Not 0 Or Less Than That!";
  } else if (maxCal && maxCal <= minCal) {
    errors.maxCal =
      "Maximum Calory Can Not Be Equal Or Less Than Minimum Calory!";
  }

  if (Array.isArray(formValues.goalDiets) && formValues.goalDiets?.length > 0) {
    formValues.goalDiets.forEach((dayForm, dayIndex) => {
      dayForm.forEach((meal, mealIndex) => {
        meal.meals.forEach((mea, meaInd) => {
          if (mea.quantity && !mea.selectedMeal) {
            if (
              !errors[`day${dayIndex}_meal${mealIndex}_selectedMeal${meaInd}`]
            ) {
              errors[`day${dayIndex}_meal${mealIndex}_selectedMeal${meaInd}`] =
                "Meal Is Required!";
            }
          } else if (mea.selectedMeal && !mea.quantity) {
            if (!errors[`day${dayIndex}_meal${mealIndex}_quantity${meaInd}`]) {
              errors[`day${dayIndex}_meal${mealIndex}_quantity${meaInd}`] =
                "quantity Is Required!";
            }
          }
        });
      });
    });
  }

  return errors;
};

export const dpGDFormValidate = (goalDiets) => {
  let errors = {};

  if (goalDiets?.length === 0) {
    goalDiets = "Goal is required!";
  }

  if (Array.isArray(goalDiets)) {
    goalDiets.forEach((dayForm, dayIndex) => {
      dayForm.forEach((meal, mealIndex) => {
        meal.meals.forEach((mea, meaInd) => {
          if (
            meal.mealTagline?.toLowerCase() === "breakfast" ||
            meal.mealTagline?.toLowerCase() === "lunch" ||
            meal.mealTagline?.toLowerCase() === "snacks" ||
            meal.mealTagline?.toLowerCase() === "dinner"
            // meal.mealTaglineValue === "RTYFVG8785743" ||
            // meal.mealTaglineValue === "DEYFVG8785742" ||
            // meal.mealTaglineValue === "RTYXCG8785742" ||
            // meal.mealTaglineValue === "PLYFVG8785742"
          ) {
            if (!mea.selectedMeal) {
              if (
                !errors[`day${dayIndex}_meal${mealIndex}_selectedMeal${meaInd}`]
              ) {
                errors[
                  `day${dayIndex}_meal${mealIndex}_selectedMeal${meaInd}`
                ] = "Meal Is Required!";
              }
            }

            if (!mea.quantity) {
              if (
                !errors[`day${dayIndex}_meal${mealIndex}_quantity${meaInd}`]
              ) {
                errors[`day${dayIndex}_meal${mealIndex}_quantity${meaInd}`] =
                  "quantity Is Required!";
              }
            }
          }
        });
      });
    });
  }

  return errors;
};

export const validateMealForm = (mealForm, mealFormImages) => {
  let errors = {};

  if (!mealForm.name) {
    errors.name = "Name is required!";
  }

  if (!mealForm.selectedRating) {
    errors.selectedRating = "Rating is required!";
  }

  if (!mealForm.selectedCategory) {
    errors.selectedCategory = "Meal Category is required!";
  }

  if (!mealForm.selectedUnit) {
    errors.selectedUnit = "Unit is required!";
  }

  if (!mealForm.protinGms) {
    errors.protinGms = "Protein (Grams) is required!";
  }

  if (!mealForm.protinCal) {
    errors.protinCal = "Protein (Cal) is required!";
  }

  if (!mealForm.carbsGms) {
    errors.carbsGms = "Carbs (Grams) is required";
  }

  if (!mealForm.carbsCal) {
    errors.carbsCal = "Carbs (Cal) is required!";
  }

  if (!mealForm.fatGms) {
    errors.fatGms = "Fat (Grams) is required!";
  }

  if (!mealForm.fatCal) {
    errors.fatCal = "Fat (Cal) is required!";
  }

  if (!mealForm.totalCalories) {
    errors.totalCalories = "Total Calories is required!";
  }

  if (!mealForm.description) {
    errors.description = "Description is required!";
  }

  if (!mealForm.method) {
    errors.method = "Method is required!";
  }

  // if (mealForm.selectedIngredients?.length === 0) {
  //   errors.selectedIngredients = "Ingredients is required!";
  // }

  if (mealFormImages.thumbnailImg.length === 0) {
    errors.thumbnailImg = "Thumbnail is required!";
  }

  if (
    mealFormImages.coverImg.length === 0 &&
    mealFormImages.video.length === 0
  ) {
    errors.coverImg = "Cover Image is required!";
  }

  return errors;
};

export const dietPlanFormValidate = (formValues, formImages) => {
  let errors = {};

  if (!formValues.planName) {
    errors.planName = "Diet Plan Name Is Required!";
  }

  if (!formValues.planDuration) {
    errors.planDuration = "Diet Plan Duration Is Required!";
  }

  if (!formValues.customizations) {
    errors.customizations = "Diet Plan Customization Is Required!";
  }

  if (!formValues.reviews) {
    errors.reviews = "Diet Plan Reviews Is Required!";
  }

  if (!formValues.calls) {
    errors.calls = "Diet Plan Calls Is Required!";
  }

  if (!formValues.taxPercentage) {
    errors.taxPercentage = "Diet Plan Tax Percentage Is Required!";
  }

  if (!formValues.pricing) {
    errors.pricing = "Diet Plan Pricing Is Required!";
  }

  if (!formValues.description) {
    errors.description = "Diet Plan Description Is Required!";
  }

  if (!formValues.whoCan) {
    errors.whoCan = "Who Can Purchase Diet Plan Is Required!";
  }

  if (!formValues.planName) {
    errors.planName = "Diet Plan Name Is Required!";
  }

  if (formImages.image.length === 0) {
    errors.image = "Diet Paln Image is required!";
  }

  return errors;
};

export const validateTPForm = (tpForm, rowData) => {
  let errors = {};

  if (!tpForm?.tpName) {
    errors.tpName = `Type Name is required!`;
  }

  if (!tpForm?.tpImg || tpForm?.tpImg.length === 0) {
    errors.tpImg = `Type Image is required!`;
  }

  if (!tpForm?.isType && !tpForm?.isPreference) {
    errors.isType = `Select Type!`;
    errors.isPreference = `Select Type!`;
  }

  if (
    rowData &&
    (rowData?.uid === "09iwUQmnUbr8u" || rowData?.uid === "93NMT1QZaOou1")
  ) {
    if (!tpForm.recomededCal) {
      errors.recomededCal = "Recomended Calory Is Required!";
    }

    if (!tpForm.extremeCal) {
      errors.extremeCal = "Extreme Calory Is Required!";
    }

    if (!tpForm.description) {
      errors.description = "Description Calory Is Required!";
    } else if (tpForm.description?.length < 45) {
      errors.description = "Description Should Be At Least 45 Characters!";
    }
  }

  // if (!tpForm?.isType && !tpForm?.isPreference) {
  //   errors.isType = `Select Type!`;
  //   errors.isPreference = `Select Type!`;
  // }

  return errors;
};
